import React from 'react';

function CreateTicket() {
    return ( 
        <div className="container border-bottom mb-5">
            <div className="row mt-3 mt-md-5 p-3 mb-md-5">
            <h1 className="fs-2">To create a ticket, select a relevant topic</h1>
            </div>
            <div className="row mt-3 mt-md-5 p-3 mb-md-5">
    <div className="col-lg-4 col-sm-12 mt-md-2 mb-2">
        <h4><i className="fa fa-plus-circle" aria-hidden="true"></i> Account Opening</h4>
        <a href="#" style={{textDecoration:"none", lineHeight:"2.5"}}> Getting started</a><br />
        <a href="#" style={{textDecoration:"none", lineHeight:"2.5"}}> Online</a><br />
        <a href="#" style={{textDecoration:"none", lineHeight:"2.5"}}> Offline</a><br />
        <a href="#" style={{textDecoration:"none", lineHeight:"2.5"}}> Charges</a><br />
        <a href="#" style={{textDecoration:"none", lineHeight:"2.5"}}> Company, Partnership and HUF</a><br />
        <a href="#" style={{textDecoration:"none", lineHeight:"2.5"}}> Non Resident Indian (NRI)</a><br />
    </div>
    
    <div className="col-lg-4 col-sm-12 mt-2 mb-2">
        <h4><i className="fa fa-credit-card" aria-hidden="true"></i> Cards & Loans</h4>
        <a href="#" style={{textDecoration:"none", lineHeight:"2.5"}}> Credit Cards</a><br />
        <a href="#" style={{textDecoration:"none", lineHeight:"2.5"}}> Debit Cards</a><br />
        <a href="#" style={{textDecoration:"none", lineHeight:"2.5"}}> Personal Loans</a><br />
        <a href="#" style={{textDecoration:"none", lineHeight:"2.5"}}> Home Loans</a><br />
        <a href="#" style={{textDecoration:"none", lineHeight:"2.5"}}> Auto Loans</a><br />
        <a href="#" style={{textDecoration:"none", lineHeight:"2.5"}}> Education Loans</a><br />
    </div>
    
    <div className="col-lg-4 col-sm-12 mt-2 mb-2">
        <h4><i className="fa fa-line-chart" aria-hidden="true"></i> Investments</h4>
        <a href="#" style={{textDecoration:"none", lineHeight:"2.5"}}> Fixed Deposits</a><br />
        <a href="#" style={{textDecoration:"none", lineHeight:"2.5"}}> Mutual Funds</a><br />
        <a href="#" style={{textDecoration:"none", lineHeight:"2.5"}}> Equity Trading</a><br />
        <a href="#" style={{textDecoration:"none", lineHeight:"2.5"}}> Retirement Plans</a><br />
        <a href="#" style={{textDecoration:"none", lineHeight:"2.5"}}> Insurance Plans</a><br />
        <a href="#" style={{textDecoration:"none", lineHeight:"2.5"}}> Tax-Saving Options</a><br />
    </div>
    
    <div className="col-lg-4 col-sm-12 mt-2 mb-2">
        <h4><i className="fa fa-mobile" aria-hidden="true"></i> Digital Banking</h4>
        <a href="#" style={{textDecoration:"none", lineHeight:"2.5"}}> Mobile Banking</a><br />
        <a href="#" style={{textDecoration:"none", lineHeight:"2.5"}}> Internet Banking</a><br />
        <a href="#" style={{textDecoration:"none", lineHeight:"2.5"}}> UPI Payments</a><br />
        <a href="#" style={{textDecoration:"none", lineHeight:"2.5"}}> Bill Payments</a><br />
        <a href="#" style={{textDecoration:"none", lineHeight:"2.5"}}> Cardless Transactions</a><br />
        <a href="#" style={{textDecoration:"none", lineHeight:"2.5"}}> Digital Statements</a><br />
    </div> 
    
    <div className="col-lg-4 col-sm-12 mt-2 mb-2">
        <h4><i className="fa fa-shield" aria-hidden="true"></i> Security & Support</h4>
        <a href="#" style={{textDecoration:"none", lineHeight:"2.5"}}> Fraud Prevention</a><br />
        <a href="#" style={{textDecoration:"none", lineHeight:"2.5"}}> Safe Banking Tips</a><br />
        <a href="#" style={{textDecoration:"none", lineHeight:"2.5"}}> Contact Support</a><br />
        <a href="#" style={{textDecoration:"none", lineHeight:"2.5"}}> Locate Branch/ATM</a><br />
        <a href="#" style={{textDecoration:"none", lineHeight:"2.5"}}> Feedback & Complaints</a><br />
        <a href="#" style={{textDecoration:"none", lineHeight:"2.5"}}> FAQs</a><br />
    </div>
    
    <div className="col-lg-4 col-sm-12 mt-2 mb-2">
        <h4><i className="fa fa-briefcase" aria-hidden="true"></i> Business Banking</h4>
        <a href="#" style={{textDecoration:"none", lineHeight:"2.5"}}> Business Accounts</a><br />
        <a href="#" style={{textDecoration:"none", lineHeight:"2.5"}}> Merchant Services</a><br />
        <a href="#" style={{textDecoration:"none", lineHeight:"2.5"}}> Corporate Cards</a><br />
        <a href="#" style={{textDecoration:"none", lineHeight:"2.5"}}> Business Loans</a><br />
        <a href="#" style={{textDecoration:"none", lineHeight:"2.5"}}> Trade Finance</a><br />
        <a href="#" style={{textDecoration:"none", lineHeight:"2.5"}}> Payroll Services</a><br />
    </div>
</div>
        </div>
     );
}

export default CreateTicket;